import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import * as actionTypes from '../../../store/actions';
import DirectTestsList from '../../Crafted/Specimen/DirectTestsList/DirectTestsList';
import ManageList from '../../Containers/ManageList/ManageList';
import ManageRecord from '../../Containers/ManageRecord/ManageRecord';
import MultiList from '../../Containers/MultiList/MultiList';
import Login from '../../Security/Login/Login';
import Graph from '../../Containers/Graph/Graph';
import Home from '../Home/Home';
import ReportingGrid from '../../Containers/ReportingGrid/ReportingGrid';

const Router = (props) => {

    const [viewConfig, setViewConfig] = useState({Type: "login"});
    const [data, setData] = useState();

    useEffect(() => {
        let newView = props.views.filter((view) => {
            return view.Name === props.currentView;
        })[0];
        if (newView === undefined) {
            newView = props.recordviews.filter((view) => {
                return view.Name === props.currentView;
            })[0];
        }
        if (newView === undefined) {
            newView = props.reportinggrids.filter((view) => {
                return view.Name === props.currentView;
            })[0];
        }
        if (newView !== undefined) {
            setViewConfig(newView);
            if (newView.Name !== "specimens") {
                setData(undefined);
            }
        }
    },[props.currentView, props.views])

    const toggleFullScreenHandler = () => {
        props.onToggleFullScreen();
    };

    const homeClickHandler = (data) => {
        props.homeClick();
        setData(data);
    }
  
    let viewToDisplay;
    if (viewConfig.Name === "graphs") {
        viewToDisplay = <Graph 
                            config={viewConfig}
                            toggleFullScreen={toggleFullScreenHandler}
                        ></Graph>
    } else {
        switch (viewConfig.Type.toLowerCase()) {
            case "directtestslist":
                viewToDisplay = <DirectTestsList
                                    config={viewConfig}
                                    data={data}
                                    toggleFullScreen={toggleFullScreenHandler}>
                                </DirectTestsList>
                break;
            case "managelist":
                viewToDisplay = <ManageList
                                    config={viewConfig}
                                    data={data}
                                    toggleFullScreen={toggleFullScreenHandler}>
                                </ManageList>
                break;
            case "multilist":
                viewToDisplay = <MultiList
                                    config={viewConfig}
                                    toggleFullScreen={toggleFullScreenHandler}>
                                </MultiList>
                break;
            case "recordview":
                viewToDisplay = <ManageRecord
                                    config={viewConfig}
                                    type={viewConfig.Name}
                                    passive={false}
                                    toggleFullScreen={toggleFullScreenHandler}>
                                </ManageRecord>
                break;
            case "reportgrid":
                viewToDisplay = <ReportingGrid
                                    config={viewConfig}
                                    language={props.language}
                                    toggleFullScreen={toggleFullScreenHandler}>
                                </ReportingGrid>
                break;
            case "home":
                viewToDisplay = <Home onClick={homeClickHandler} language={props.language}></Home>
                break;
            default:
                viewToDisplay = <Login successfulLogin={props.successfulLogin} language={props.language}></Login>
        }
    }
    
    return (
        <React.Fragment>
            {viewToDisplay}
        </React.Fragment>
    )
};

const mapStateToProps = state => {
    return {
        views: state.config.views,
        recordviews: state.config.recordviews,
        reportinggrids: state.config.reportinggrids,
        language: state.config.language
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleFullScreen: () => dispatch({type: actionTypes.TOGGLEFULLSCREEN})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Router);